/**
 * Maximum allowed size for patient file uploads (5MB)
 */
export const MAX_PATIENT_FILE_SIZE = 5 * 1024 * 1024;
export const PATIENT_FILE_TYPES = ['application/pdf'];
/**
 * Validates if the provided content type is allowed for patient file uploads.
 * Accepts any image type and PDF files.
 *
 * @param contentType - The MIME type to validate
 * @returns True if the content type is valid, false otherwise
 *
 * @__NO_SIDE_EFFECTS__
 */
export function isPatientFileContentTypeValid(contentType) {
    return contentType.startsWith('image/') || PATIENT_FILE_TYPES.includes(contentType);
}
//# sourceMappingURL=patientFileValidation.js.map